import React from 'react';
import { useTranslation } from 'react-i18next';
import ataCarnetLogo from '../assets/images/ata-carnet.svg';

const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <header className="u-header">
      <div className="u-logo">
        <img src={ataCarnetLogo} alt={t('header.altText')} />
      </div>
    </header>
  );
};

export default Header;
